<template>
  <vue-validation-field
    :name="name"
    :tag="tag"
    :is-equal="isEqual"
    @change="$emit('change', $event)"
    @should-focus="handleFocus"
  >
    <template #default="scopedProps">
      <slot
        v-bind="scopedProps"
        name="nude"
      >
        <input
          v-if="hidden"
          v-bind="$attrs"
          type="hidden"
          :name="scopedProps.name"
          :value="scopedProps.modelValue"
        >
        <form-field
          v-else
          v-bind="$attrs"
          :label="label"
          :description="description"
          :hide-errors="hideErrors"
          :show-only-one-error="showOnlyOneError"
          :invalid="scopedProps.invalid"
          :errors="scopedProps.errors"
        >
          <template #label="labelScoped">
            <slot
              name="label"
              v-bind="{
                ...scopedProps,
                ...labelScoped
              }"
            />
          </template>
          <template #hint>
            <slot
              v-bind="{ ...scopedProps }"
              name="hint"
            />
          </template>
          <template #additional-control>
            <slot
              v-bind="{ ...scopedProps }"
              name="additional-control"
            />
          </template>
          <template #default="{ id }">
            <slot
              v-bind="scopedProps"
              :id="id"
            />
          </template>
          <template #error="{ error }">
            <slot
              name="error"
              v-bind="{
                error,
                ...scopedProps
              }"
            >
              {{ error.message }}
            </slot>
          </template>
          <template #warning>
            <slot
              v-bind="scopedProps"
              name="warning"
            />
          </template>
          <template #info>
            <slot
              v-bind="scopedProps"
              name="info"
            />
          </template>
        </form-field>
      </slot>
    </template>
  </vue-validation-field>
</template>

<script>
import { ValidationField as VueValidationField } from 'vue-validate-form';
import FormField from '../form-field/form-field.vue';

export default {
  name: 'ValidationField',
  components: {
    FormField,
    VueValidationField
  },
  inheritAttrs: false,
  props: {
    name: VueValidationField.props.name,
    tag: VueValidationField.props.tag,
    isEqual: VueValidationField.props.isEqual,
    showOnlyOneError: FormField.props.showOnlyOneError,
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    hideErrors: Boolean,
    hidden: Boolean
  },
  emits: ['change'],
  methods: {
    handleFocus() {
      this.$nextTick(() => {
        this.$el.parentNode.querySelector(`[name="${this.name}"]`)?.focus();
      });
    }
  }
};
</script>

<i18n lang="json">{}</i18n>
